export default "__VITE_ASSET__CxHQfX_A__"